import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { motion } from 'framer-motion'

type GroupButtonProps = {
  unfolded?: boolean
}

const groupButtonUnfolded = ({ unfolded }: GroupButtonProps) =>
  unfolded &&
  css`
    > svg {
      color: ${themeGet('colors.danger.default')};
    }
  `

const shouldForwardProp = (prop: string | number) => {
  return !['unfolded'].includes(String(prop))
}

export const GroupButton = styled.button.withConfig({
  shouldForwardProp,
})<GroupButtonProps>`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 24px;
  gap: ${themeGet('space.5')}px;

  > svg {
    color: ${themeGet('colors.success.default')};
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    transition: color ${themeGet('defaultTransitionTime')};
  }

  ${groupButtonUnfolded}
`

export const CollapseContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  font-size: 16px;
  font-weight: 350;

  > p {
    margin-left: 40px;
    margin-block: 0;
  }

  strong {
    font-weight: 500;
  }

  > ul {
    padding-inline-start: 60px;
  }

  a {
    text-decoration: none;
    font-weight: 400;
  }
`
